function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActivitiesNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 15.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-activities-normal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.31,3.52H17.44A.56.56,0,0,0,18,3V1.55A.56.56,0,0,0,17.44,1H7.31a.56.56,0,0,0-.56.56V3A.56.56,0,0,0,7.31,3.52Zm0,5.62H17.44A.56.56,0,0,0,18,8.58V7.17a.56.56,0,0,0-.56-.56H7.31a.56.56,0,0,0-.56.56V8.58A.56.56,0,0,0,7.31,9.14Zm0,5.62H17.44A.56.56,0,0,0,18,14.2V12.8a.56.56,0,0,0-.56-.56H7.31a.56.56,0,0,0-.56.56V14.2A.56.56,0,0,0,7.31,14.77Zm-5.06-3a1.69,1.69,0,1,0,0,3.37,1.69,1.69,0,0,0,0-3.37ZM5.5,1.3,3,3.84l-.55.55a.45.45,0,0,1-.62,0L.12,2.72a.42.42,0,0,1,0-.6l.55-.55a.42.42,0,0,1,.6,0l.8.78L4.31.12a.42.42,0,0,1,.6,0l.6.58A.43.43,0,0,1,5.5,1.3Zm0,5.61L3,9.45,2.41,10a.45.45,0,0,1-.62,0L.12,8.33a.42.42,0,0,1,0-.6l.55-.55a.42.42,0,0,1,.6,0l.8.78L4.31,5.72a.42.42,0,0,1,.6,0l.6.6a.42.42,0,0,1,0,.59Z",
    style: {
      fill: "#999"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActivitiesNormal);
export default __webpack_public_path__ + "static/media/icon-activities-normal.235420b06fcc42c7067e081ce20b6732.svg";
export { ForwardRef as ReactComponent };